import { baseApiAuthenticated } from '@/api/v2/index';
import { Customer } from '@/models/customer';
import { buildSearchParams, urlBuilder } from '@/api/utils';
import { transformCustomerFromResponse } from '@/models/customer';
import { BackendType, FrontendType, ObjectType } from '@/models/general';

const baseUrl = urlBuilder('auth', 'customers');

export type GetCustomerSearchParams = {
    size?: number;
    page?: number;
    sort?: string;
    search?: string;
};

type GetCustomerResponse<T extends ObjectType = FrontendType> = {
    content: Customer<T>[];
    size: number;
    totalElements: number;
    totalPages: number;
};

export const customerApi = baseApiAuthenticated.injectEndpoints({
    endpoints: (builder) => ({
        getCustomers: builder.query<
            GetCustomerResponse,
            GetCustomerSearchParams | null
        >({
            query: (searchParams: GetCustomerSearchParams) =>
                `${baseUrl}${buildSearchParams(searchParams)}`,

            transformResponse(response: GetCustomerResponse<BackendType>) {
                return {
                    ...response,
                    content: response.content.map(
                        transformCustomerFromResponse
                    ),
                };
            },
        }),
    }),
});

export const { useGetCustomersQuery } = customerApi;
